import settings from "../settings";

const getBaseUrl = () => {
    return process.env.REACT_APP_ENVIRONMENT === "prod"
        ? settings.appUrlProduction
        : settings.appUrlStaging;
};

export default getBaseUrl;
